import BaseModel from './BaseModel'

export default class Smsacceptance extends BaseModel {
  static entity = 'smsacceptances'
  static primaryKey = 'acceptance_id'

  static fields() {
    return {
      acceptance_id: this.attr(),
      acceptancetype_id: this.attr(),
      phonenumber: this.string(),
      text: this.string(),
      screenshotpath: this.string(),
    }
  }
}
